import { type UiI18n } from '@myre/domain-i18n-wordings';
import { type TextItem } from '@myre/ui-primitive-actions-dropdown';

export function generateLegalDropdownItems(wordings: UiI18n): TextItem[] {
  const system = wordings._ui.legal.system;

  return [
    system.cookiesPolicy,
    system.gdpr,
    system.legalInformation,
    system.privacyPolicy,
    system.terms,
  ].map(item => ({
    label: item.name(),
    onClick: () => window.open(item.url(), '_blank'),
  }));
}
